<template>
    <b-row>
        <b-col md="4" cols="12">
            <info-card
            label="الجهة المقدمة للمعاملة"
            :value="ngo.name_ar"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label=" المقر" :value="ngo.hq.name_ar" />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="الشكل القانوني للجهة المقدمة للمعاملة"
            :value="ngo.legalForm.name_ar"
            />
        </b-col>
        <b-col md="4" cols="12" v-if="user">
            <info-card label=" مقدم المعاملة" 
            :value="user.full_name" />
        </b-col>
    </b-row>
</template>

<script>
import { BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
import InfoCard from "@/components/InfoCard.vue";
export default {
    components: {
     BCol , InfoCard , BRow , BButton
    },
    props: {
        ngo: Object  ,
        user : Object  ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
};
</script>